import { Components, Theme } from "@mui/material";

export const MuiTabs: Components<Theme>["MuiTabs"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      "& .MuiTabs-flexContainer": {
        gap: theme.spacing(3),
      },
    }),
  },
};
